import React from 'react';

function ManageSkillList() {
  return (
    <> 
    <div class="row" width="100%"> 
    <h4>Methodologies</h4>
        <ul>
          <li>Agile</li>
          <li>Scrum</li>
          <li>Waterfall</li>
        </ul>
    <h4>Management Tools</h4>
        <ul>
          <li>Jira</li>
          <li>Confluence</li>
          <li>Asana</li>
          <li>Trello</li>
        </ul>
    <h4>Skills</h4>
        <ul>
        <li><b>Communication:</b> strong communication skills for ensuring planning aligns with the expectations of lead 
        stakeholders and each member of the team has a clear understanding of their role in project success </li>
          <li><b>Planning and Scheduling:</b> creating goals, milestones, timelines, and workflow schedules </li>
          <li><b>Budget and Resource Allocation:</b> tracking budgets, procuring resources, and allocating resource use and time </li>
          <li><b>Time Management: </b> organizing and prioritizing tasks to ensure on time completion of the project </li>
          <li><b>Risk Management and Issue Tracking:</b> planning contingency plans for risks that can be anticipated and responding to unexpected 
            issues finding solutions to keep the project on track </li>
          <li><b>Team Collaboration:</b>  experience working with cross-functional teams and fostering communication and collaboration 
            across different departments </li>
        </ul>
      </div>
    </>
  )
};

export default ManageSkillList;